import { AttributeRestriction, RestrictionAttribute } from "components/restrictions/Restrictions";
import { ComponentDefinition, DisplayedComponent, HideableComponent } from "./Component";

export abstract class ValueBaseComponent<T extends ComponentDefinition>
    implements DisplayedComponent, HideableComponent {
    /**
     * A name that uniquely identifies the type of the component.
     */
    public componentType: string;
    /**
     * A name that uniquely identifies the component.
     */
    public id: string;
    public definition: T;
    public view: HTMLElement;

    constructor(schema: T) {
        this.definition = schema;
        this.id = schema.id;
    }

    public abstract render(): Element;

    public hide() {
        (this.view as HTMLElement).style.display = "none";
    }

    public show() {
        (this.view as HTMLElement).style.display = "block";
    }

    public applyRestrictions(restricions: AttributeRestriction) {
        if (restricions == null || restricions.attributes == null) {
            return;
        }
        if (restricions.attributes.includes(RestrictionAttribute.hidden)) {
            this.hide();
        } else {
            this.show();
        }
    }
}
